var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"submenu__divider"},[_c('Divider',{attrs:{"color":"gray300","thickness":"1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }